export const FormatDatuma = {
  methods: {
    PoenotenIzgledDatuma (prenosniParameter, showTime = true) {
      let izpisFormatDatuma = prenosniParameter instanceof Date ? prenosniParameter : new Date(prenosniParameter)
      if (!isNaN(izpisFormatDatuma)) {
        let dan = izpisFormatDatuma.getDate()
        let mesec = izpisFormatDatuma.getMonth() + 1
        if (dan < 10) {
          dan = '0' + dan
        }
        if (mesec < 10) {
          mesec = '0' + mesec
        }
        let datumOut = dan + '.' + mesec + '.' + izpisFormatDatuma.getFullYear()
        if (showTime) {
          datumOut += ' ' +
            ('00' + izpisFormatDatuma.getHours()).slice(-2) + ':' +
            ('00' + izpisFormatDatuma.getMinutes()).slice(-2) + ':' +
            ('00' + izpisFormatDatuma.getSeconds()).slice(-2)
        }
        return datumOut
      }
      return 'Ni podatka'
    },
    PoenotenIzgledDatumaBrezCasa (prenosniParameter) {
      let izpisFormatDatuma = new Date(prenosniParameter)
      let dan = izpisFormatDatuma.getDate()
      let mesec = izpisFormatDatuma.getMonth() + 1
      if (dan < 10) {
        dan = '0' + dan
      }
      if (mesec < 10) {
        mesec = '0' + mesec
      }
      izpisFormatDatuma = dan + '.' + mesec + '.' + izpisFormatDatuma.getFullYear()
      return izpisFormatDatuma.toLocaleString()
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/FormatDatuma.js